"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports._ModalBase = exports.ModalBase = exports.DEFAULT_MODAL_Z_INDEX = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _styledSystem = require("styled-system");
var _usePortal2 = require("../../utils/usePortal");
var _Flex = require("../Flex");
var _reactFocusOn = require("react-focus-on");
var _excluded = ["children", "zIndex", "dialogProps", "onClose"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var Focus = (0, _styledComponents.default)(_reactFocusOn.FocusOn).withConfig({
  displayName: "ModalBase__Focus",
  componentId: "sc-g18dlb-0"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
var Backdrop = _styledComponents.default.div.withConfig({
  displayName: "ModalBase__Backdrop",
  componentId: "sc-g18dlb-1"
})(["width:100%;height:100%;display:flex;align-items:center;justify-content:center;"]);
var Container = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "ModalBase__Container",
  componentId: "sc-g18dlb-2"
})(["position:fixed;top:0;right:0;bottom:0;left:0;align-items:center;justify-content:center;", ""], _styledSystem.zIndex);
var Dialog = (0, _styledComponents.default)(_Flex.Flex).attrs({
  role: "dialog"
}).withConfig({
  displayName: "ModalBase__Dialog",
  componentId: "sc-g18dlb-3"
})(["overflow-y:auto;-webkit-overflow-scrolling:touch;> *{max-height:100%;}"]);

/** BaseModal */

/**
 * It seems we've landed on this value as the 'top'
 */
var DEFAULT_MODAL_Z_INDEX = 9999;

/**
 * BaseModal
 * Low-level modal that has no opinions about layout/overlay
 * Modals content using a portal, locks scroll.
 */
exports.DEFAULT_MODAL_Z_INDEX = DEFAULT_MODAL_Z_INDEX;
var ModalBase = function ModalBase(props) {
  if (typeof window === "undefined") {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_ModalBase, props);
};
exports.ModalBase = ModalBase;
ModalBase.displayName = "ModalBase";
var _ModalBase = function _ModalBase(_ref) {
  var children = _ref.children,
    _ref$zIndex = _ref.zIndex,
    zIndex = _ref$zIndex === void 0 ? DEFAULT_MODAL_Z_INDEX : _ref$zIndex,
    _ref$dialogProps = _ref.dialogProps,
    dialogProps = _ref$dialogProps === void 0 ? {} : _ref$dialogProps,
    _ref$onClose = _ref.onClose,
    onClose = _ref$onClose === void 0 ? function () {
      return null;
    } : _ref$onClose,
    rest = _objectWithoutProperties(_ref, _excluded);
  var focusEl = (0, _react.useRef)(null);
  var backdropEl = (0, _react.useRef)(null);
  var handleMouseDown = function handleMouseDown(event) {
    if (event.target === backdropEl.current) {
      onClose();
    }
  };
  (0, _react.useEffect)(function () {
    var handleKeydown = function handleKeydown(event) {
      switch (event.key) {
        case "Escape":
          // Prevent <esc> from interfering with the returned focus
          event.preventDefault();
          event.stopPropagation();

          // Handle close
          return onClose();
        default:
          break;
      }
    };
    document.addEventListener("keydown", handleKeydown);
    return function () {
      document.removeEventListener("keydown", handleKeydown);
    };
  }, [onClose]);

  // Sets to `innerHeight` so as to simulate `100vh` on iOS
  var _useState = (0, _react.useState)(window.innerHeight),
    _useState2 = _slicedToArray(_useState, 2),
    maxHeight = _useState2[0],
    setMaxHeight = _useState2[1];

  // Keeps `maxHeight` in sync
  (0, _react.useEffect)(function () {
    var updateMaxHeight = function updateMaxHeight() {
      setMaxHeight(window.innerHeight);
    };

    // Due to the dialog being portaled; we need to wait until the next tick
    // before we can perform any operations that rely on the sizing of elements.
    // Presumably anything that relies on this also listens to resize for updates.
    setTimeout(function () {
      window.dispatchEvent(new Event("resize"));
    }, 0);
    window.addEventListener("resize", updateMaxHeight, {
      passive: true
    });
    return function () {
      window.removeEventListener("resize", updateMaxHeight);
    };
  }, []);
  var _usePortal = (0, _usePortal2.usePortal)(),
    createPortal = _usePortal.createPortal;
  return createPortal( /*#__PURE__*/_react.default.createElement(Container, _extends({
    zIndex: zIndex
  }, rest), /*#__PURE__*/_react.default.createElement(Focus, {
    ref: focusEl
  }, /*#__PURE__*/_react.default.createElement(Backdrop, {
    ref: backdropEl,
    onMouseDown: handleMouseDown
  }, /*#__PURE__*/_react.default.createElement(Dialog, _extends({
    maxHeight: maxHeight
  }, dialogProps), children)))));
};
exports._ModalBase = _ModalBase;
ModalBase.displayName = "ModalBase";
//# sourceMappingURL=ModalBase.js.map